
export default function About() {
  const openWhatsApp = () => {
    const message = encodeURIComponent('Olá! Estou interessado em conhecer mais sobre a DataPrec e como vocês podem ajudar minha empresa com soluções de dados. Podemos conversar?');
    window.open(`https://wa.me/5531981041870?text=${message}`, '_blank');
  };

  return (
    <>
      {/* Linha separadora */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
      
      <section id="sobre" className="py-16 bg-gray-50 relative overflow-hidden">
        {/* Padrão de fundo sutil */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-20 w-32 h-32 bg-blue-600 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 bg-indigo-600 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-building-line"></i>
              Conheça a DataPrec
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              Sobre a <span className="text-blue-600">DataPrec</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Inteligência de dados que transforma oportunidades em resultados concretos
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Imagem */}
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl blur opacity-20 group-hover:opacity-30 transition-opacity"></div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20Brazilian%20legal%20tech%20office%20with%20professionals%20analyzing%20data%20on%20large%20screens%2C%20sophisticated%20workspace%20with%20blue%20lighting%2C%20lawyers%20and%20data%20scientists%20collaborating%20on%20precatory%20analysis%2C%20high-tech%20environment%20with%20charts%20and%20legal%20documents%2C%20professional%20atmosphere%20with%20modern%20furniture%20and%20technology&width=700&height=420&seq=about-dataprec-modern-v2&orientation=landscape"
                alt="Equipe DataPrec"
                className="relative rounded-2xl shadow-2xl w-full h-[420px] object-cover object-center transform group-hover:scale-105 transition-transform duration-500"
              />
              
              {/* Badge flutuante */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-xl border border-gray-100">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                    <i className="ri-database-2-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Especialistas em</p>
                    <p className="font-semibold text-gray-900">Dados Jurídicos</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Conteúdo */}
            <div className="space-y-8">
              {/* Missão */}
              <div className="group">
                <div className="flex items-start gap-6">
                  <div className="relative">
                    <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow">
                      <i className="ri-flag-line text-white text-2xl"></i>
                    </div>
                    <div className="absolute -inset-2 bg-blue-500/20 rounded-2xl blur group-hover:blur-md transition-all opacity-0 group-hover:opacity-100"></div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Nossa Missão</h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      Democratizar o acesso à informação sobre precatórios e RPV através de inteligência que impulsiona resultados estratégicos.
                    </p>
                  </div>
                </div>
              </div>

              {/* Visão */}
              <div className="group">
                <div className="flex items-start gap-6">
                  <div className="relative">
                    <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow">
                      <i className="ri-eye-line text-white text-2xl"></i>
                    </div>
                    <div className="absolute -inset-2 bg-teal-500/20 rounded-2xl blur group-hover:blur-md transition-all opacity-0 group-hover:opacity-100"></div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Nossa Visão</h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      Ser referência em tecnologia para o mercado de precatórios e RPV, conectando oportunidades e facilitando negócios.
                    </p>
                  </div>
                </div>
              </div>

              {/* Valores */}
              <div className="group">
                <div className="flex items-start gap-6">
                  <div className="relative">
                    <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow">
                      <i className="ri-heart-line text-white text-2xl"></i>
                    </div>
                    <div className="absolute -inset-2 bg-purple-500/20 rounded-2xl blur group-hover:blur-md transition-all opacity-0 group-hover:opacity-100"></div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Nossos Valores</h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      Transparência, inovação e excelência técnica. Acreditamos no poder dos dados para transformar o mercado jurídico.
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="pt-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-6 text-white">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-xl font-semibold mb-2">Pronto para começar?</h4>
                      <p className="text-blue-100">Descubra como podemos ajudar seu negócio</p>
                    </div>
                    <button 
                      onClick={openWhatsApp}
                      className="bg-white text-blue-600 px-6 py-3 rounded-xl font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Falar Conosco
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
